import type { Geometry } from 'geojson';

/** Feature geometry from an action's FormGeoLocationField / GeoLocation JSON. */
export const getActionGeoJsonGeometry = (
  geolocation: unknown
): Geometry | null => {
  if (!geolocation || typeof geolocation !== 'object') return null;
  const geometry = (
    geolocation as {
      geojson?: { data?: { features?: { geometry?: Geometry }[] } };
    }
  ).geojson?.data?.features?.[0]?.geometry;
  if (!geometry?.type) return null;
  return geometry;
};

/** Extract lon/lat from an action's FormGeoLocationField / GeoLocation JSON. */
export const getActionCoordinates = (
  geolocation: unknown
): { longitude: number; latitude: number } | null => {
  if (!geolocation || typeof geolocation !== 'object') return null;

  const loc = geolocation as {
    centroid?: { geometry?: { coordinates?: unknown; type?: string } };
    geojson?: {
      data?: {
        features?: { geometry?: { coordinates?: unknown; type?: string } }[];
      };
    };
  };

  const fromCentroid = loc.centroid?.geometry?.coordinates;
  if (Array.isArray(fromCentroid) && fromCentroid.length >= 2) {
    const [longitude, latitude] = fromCentroid as [number, number];
    if (Number.isFinite(longitude) && Number.isFinite(latitude)) {
      return { longitude, latitude };
    }
  }

  const fromFeature = loc.geojson?.data?.features?.[0]?.geometry?.coordinates;
  if (Array.isArray(fromFeature) && fromFeature.length >= 2) {
    const [longitude, latitude] = fromFeature as [number, number];
    if (Number.isFinite(longitude) && Number.isFinite(latitude)) {
      return { longitude, latitude };
    }
  }

  return null;
};
